import { render, staticRenderFns } from "./NocFormGroup.vue?vue&type=template&id=de98a934"
import script from "./NocFormGroup.vue?vue&type=script&lang=js"
export * from "./NocFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports